import { getApp } from 'realm-web';
import { useConfig } from './config';

export const Realm = () => {
  const config = useConfig();
  return getApp(config.realmId);
};
